module.exports = __webpack_public_path__ + "img/yi1.2c92c805.jpg";